import { render } from "./ChangeMail.vue?vue&type=template&id=bc047572"
import script from "./ChangeMail.vue?vue&type=script&lang=js"
export * from "./ChangeMail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__